/**
 * 遷移アニメーションを定義
 */
import gsap from 'gsap';

const getTransitionItem = (): HTMLElement | null => {
  return document.getElementById('transition-item');
};

/**
 * 共通 - Page Out Animation
 */
export const commonPageOut = () => {
  const transitionItem = getTransitionItem();
  if (!transitionItem) return Promise.resolve();

  return new Promise<void>(resolve => {
    gsap.fromTo(transitionItem,
      { yPercent: 0, },
      {
        yPercent: -100,
        duration: 0.4,
        ease: 'power4.out',
        onComplete: () => resolve(),
      },
    );
  });
}

/**
 * 共通 - Page In Animation
 */
export const commonPageIn = () => {
  const transitionItem = getTransitionItem();
  if (!transitionItem) return Promise.resolve();

  return new Promise<void>(resolve => {
    gsap.fromTo(transitionItem,
      { yPercent: -100, },
      {
        yPercent: -200,
        duration: 0.6,
        ease: "power2.out",
        onComplete: () => resolve(),
      },
    );
  });
};
